import { useNavigate } from "react-router-dom";
import useExameStore from "../zustand/use-exame-store";
import useLivroStore from "../zustand/use-livro-store";
import usePerguntaStore from "../zustand/use-pergunta-store";

export const ViewModelPageHome = () => {

  const navigate = useNavigate();

  const { resetState: resetExames } = useExameStore((state) => ({ resetState: state.resetState }));
  const { resetState: resetPerguntas } = usePerguntaStore((state) => ({ resetState: state.resetState }));
  const { resetState: resetLivros } = useLivroStore((state) => ({ resetState: state.resetState }))

  const handleResetState = () => {
    resetExames();
    resetLivros();
    resetPerguntas();
  }

  return {
    navigate,
    handleResetState
  }
}